/* === SEUDA THEME JS === */

// Nur auf echten Desktop-Zeigern (Maus), nicht auf Touch/Handy
var IS_DESKTOP = window.matchMedia('(pointer: fine)').matches && window.innerWidth > 900;

// CURSOR — smooth, no lag (nur Desktop)
var c1 = document.getElementById('c1'), c2 = document.getElementById('c2');
if (IS_DESKTOP && c1 && c2) {
  var mx = 0, my = 0, cx = 0, cy = 0, raf;
  document.addEventListener('mousemove', function(e) {
    mx = e.clientX; my = e.clientY;
    c1.style.transform = 'translate(' + (mx-5) + 'px,' + (my-5) + 'px)';
    if (!raf) raf = requestAnimationFrame(trail);
  }, { passive: true });
  function trail() {
    cx += (mx - cx) * 0.18; cy += (my - cy) * 0.18;
    c2.style.transform = 'translate(' + (cx-18) + 'px,' + (cy-18) + 'px)';
    raf = Math.abs(mx-cx) + Math.abs(my-cy) > 0.3 ? requestAnimationFrame(trail) : null;
  }
  document.addEventListener('mouseover', function(e) {
    var t = e.target.closest('button, a, .pc, .mbtn, .faq-q');
    document.body.classList.toggle('hov', !!t);
  }, { passive: true });
}

// MAGNETIC BUTTONS
document.querySelectorAll('.mbtn').forEach(function(b) {
  b.addEventListener('mousemove', function(e) {
    var r = b.getBoundingClientRect();
    b.style.transform = 'translate(' + ((e.clientX - r.left - r.width/2) * .2) + 'px,' + ((e.clientY - r.top - r.height/2) * .2) + 'px)';
  });
  b.addEventListener('mouseleave', function() { b.style.transform = ''; });
});

// NAV SCROLL
window.addEventListener('scroll', function() {
  var nav = document.getElementById('nav');
  if (nav) nav.classList.toggle('sh', window.scrollY > 60);
}, { passive: true });

// FAQ ACCORDION
function toggleFaq(i) {
  document.querySelectorAll('.faq-item').forEach(function(el, j) {
    if (j !== i) el.classList.remove('open');
  });
  var item = document.getElementById('fi' + i);
  if (item) item.classList.toggle('open');
}

// STATS COUNTER
function initStats() {
  var els = document.querySelectorAll('[data-val]');
  if (!els.length) return;
  var obs = new IntersectionObserver(function(entries) {
    entries.forEach(function(entry) {
      if (!entry.isIntersecting) return;
      var el = entry.target;
      var target = parseInt(el.dataset.val) || 0;
      var suf = el.dataset.suf || '';
      if (target === 0) { el.textContent = '0' + suf; return; }
      var cur = 0, step = Math.ceil(target / 40);
      var iv = setInterval(function() {
        cur = Math.min(cur + step, target);
        el.textContent = cur + suf;
        if (cur >= target) clearInterval(iv);
      }, 35);
      obs.unobserve(el);
    });
  }, { threshold: 0.3 });
  els.forEach(function(el) { obs.observe(el); });
}

// SCROLL REVEAL
function initReveal() {
  var io = new IntersectionObserver(function(entries) {
    entries.forEach(function(e) {
      if (e.isIntersecting) { e.target.classList.add('in'); io.unobserve(e.target); }
    });
  }, { threshold: 0.1 });
  document.querySelectorAll('.rv, .rv-l, .rv-r').forEach(function(el) {
    if (!el.classList.contains('in')) io.observe(el);
  });
}

// TOAST
var toastT;
function showToast(m) {
  clearTimeout(toastT);
  var t = document.getElementById('toast');
  if (!t) return;
  t.textContent = m; t.style.display = 'block';
  toastT = setTimeout(function() { t.style.display = 'none'; }, 2200);
}

// 3D TILT CARDS
function initTilt() {
  document.querySelectorAll('.pc').forEach(function(card) {
    var shine = document.createElement('div');
    shine.className = 'pc-shine';
    card.appendChild(shine);
    card.style.transformStyle = 'preserve-3d';

    card.addEventListener('mousemove', function(e) {
      var r = card.getBoundingClientRect();
      var x = e.clientX - r.left;
      var y = e.clientY - r.top;
      var cx = r.width / 2;
      var cy = r.height / 2;
      var rotX = ((y - cy) / cy) * -10;
      var rotY = ((x - cx) / cx) * 10;
      card.style.transform = 'perspective(900px) rotateX(' + rotX + 'deg) rotateY(' + rotY + 'deg) scale3d(1.03,1.03,1.03)';
      var gx = (x / r.width) * 100;
      var gy = (y / r.height) * 100;
      shine.style.background = 'radial-gradient(circle at ' + gx + '% ' + gy + '%, rgba(255,255,255,.18) 0%, transparent 65%)';
      shine.style.opacity = '1';
    });
    card.addEventListener('mouseleave', function() {
      card.style.transform = 'perspective(900px) rotateX(0) rotateY(0) scale3d(1,1,1)';
      shine.style.opacity = '0';
    });
  });
}

// SCROLL PROGRESS BAR
function initProgress() {
  var bar = document.createElement('div');
  bar.id = 'spb';
  document.body.appendChild(bar);
  window.addEventListener('scroll', function() {
    var s = document.documentElement.scrollTop;
    var h = document.documentElement.scrollHeight - window.innerHeight;
    bar.style.width = (s / h * 100) + '%';
  }, { passive: true });
}

// PARALLAX HERO
function initParallax() {
  var slides = document.querySelectorAll('.slide');
  if (!slides.length) return;
  window.addEventListener('scroll', function() {
    var y = window.scrollY;
    slides.forEach(function(s) {
      s.style.backgroundPositionY = 'calc(center + ' + (y * 0.35) + 'px)';
    });
  }, { passive: true });
}

// WORD-BY-WORD TEXT REVEAL (nur Desktop — auf Handy ruckelt/versteckt es Text)
function initWordReveal() {
  if (!IS_DESKTOP) return;
  document.querySelectorAll('.sec-h, .nl-h, .about-text').forEach(function(el) {
    if (el.dataset.split) return;
    if (el.childElementCount > 0) return;
    el.dataset.split = '1';
    var html = el.innerHTML;
    el.innerHTML = html.replace(/(\S+)/g, '<span class="wr"><span>$1</span></span>');
  });
  var io = new IntersectionObserver(function(entries) {
    entries.forEach(function(e) {
      if (!e.isIntersecting) return;
      e.target.querySelectorAll('.wr span').forEach(function(s, i) {
        s.style.transitionDelay = (i * 0.04) + 's';
        s.classList.add('in');
      });
      io.unobserve(e.target);
    });
  }, { threshold: 0.2 });
  document.querySelectorAll('.sec-h, .nl-h').forEach(function(el) { io.observe(el); });
}

// STAGGERED CARD ENTRANCE
function initStagger() {
  var io = new IntersectionObserver(function(entries) {
    entries.forEach(function(e) {
      if (!e.isIntersecting) return;
      var cards = e.target.querySelectorAll('.pc, .test-card, .faq-item');
      cards.forEach(function(c, i) {
        setTimeout(function() { c.classList.add('stag-in'); }, i * 90);
      });
      io.unobserve(e.target);
    });
  }, { threshold: 0.1 });
  document.querySelectorAll('.fp-grid, .test-grid, .faq-list').forEach(function(g) { io.observe(g); });
}

// HORIZONTAL LINE REVEAL on section separators
function initLineReveal() {
  var io = new IntersectionObserver(function(entries) {
    entries.forEach(function(e) {
      if (e.isIntersecting) { e.target.classList.add('line-in'); io.unobserve(e.target); }
    });
  }, { threshold: 0.5 });
  document.querySelectorAll('.sec-tag').forEach(function(el) { io.observe(el); });
}

// VIDEO-AUTOPLAY-WÄCHTER (06.09.2026, live 08.09.2026): iOS-Stromsparmodus und Datensparmodus blockieren
// Autoplay und blenden einen Play-Button ins Video. Dann: Host bekommt .video-blocked (CSS versteckt das
// Video, das Poster im Hintergrund übernimmt) und beim ersten Tippen/Scrollen wird der Start erneut versucht.
function initVideoGuard() {
  document.querySelectorAll('video[data-guard]').forEach(function(v) {
    var host = v.closest('[data-guard-host]') || v.parentElement;
    function blocked() { host.classList.add('video-blocked'); }
    function playing() { host.classList.remove('video-blocked'); }
    v.addEventListener('playing', playing);
    function attempt() {
      var p = v.play();
      if (p && p.catch) p.catch(blocked);
    }
    attempt();
    setTimeout(function() { if (v.paused) blocked(); }, 1500);
    ['touchstart', 'pointerdown', 'scroll', 'keydown'].forEach(function(ev) {
      window.addEventListener(ev, function() { if (v.paused) attempt(); }, { once: true, passive: true });
    });
  });
}

// INIT
document.addEventListener('DOMContentLoaded', function() {
  initVideoGuard();
  initReveal();
  initStats();
  initProgress();
  initWordReveal();
  initStagger();
  initLineReveal();
});
